import React from 'react';
import { Box, Grid, Skeleton } from '@mui/material';

export const MetricsSkeleton = () => {
  return (
    <Box
      sx={{
        flexGrow: 1,
      }}
    >
      <Grid container spacing={3}>
        {[1, 2, 3, 4, 5].map((index) => (
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={3}
            key={`skeleton-${index}`}
          >
            <Box
              sx={{
                borderRadius: 2,
                p: 3,
                backgroundColor: 'background.paper',
                boxShadow: '0 2px 8px rgba(15, 40, 76, 0.05)',
                border: '1px solid',
                borderColor: 'divider',
              }}
            >
              <Skeleton 
                variant="text" 
                width="60%" 
                height={48} 
                sx={{ mb: 2 }} 
              />
              <Skeleton 
                variant="text" 
                width="100%" 
                height={24} 
              />
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

